// var tools = (function($) {
//     var isIE = !1;
//     var IEVersion = !1;
//     var isSafari = !1;
//     var isIOS = !1;
//     var md = new MobileDetect(window.navigator.userAgent);
//     var init = function() {
//         bindEvents();
//         if (md.mobile())
//             $('html').addClass('is-mobile')
//     }
//     var bindEvents = function() {
//         $('body').on('mousedown', 'img', function() {
//             return !1
//         })
//     }
//     var isDesktop = function() {
//         return window.matchMedia("(min-width: 1366px)").matches
//     }
//     var isTablet = function() {
//         return window.matchMedia("(max-width: 1365px) and (min-width: 768px)").matches
//     }
//     var isSmartphone = function() {
//         return window.matchMedia("(max-width:720px) and (orientation: portrait), (max-width:900px) and (orientation: landscape)").matches
//     }
//     var isHandheld = function() {
//         return (isTablet() || isSmartphone())
//     }
//     var checkIE = function() {
//         var rv = -1;
//         var ua = null;
//         var re = null;
//         if (navigator.appName == 'Microsoft Internet Explorer') {
//             ua = navigator.userAgent;
//             re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
//             if (re.exec(ua) != null)
//                 rv = parseFloat(RegExp.$1)
//         } else if (navigator.appName == 'Netscape') {
//             ua = navigator.userAgent;
//             re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
//             if (re.exec(ua) != null)
//                 rv = parseFloat(RegExp.$1)
//         }
//         if (rv === -1) {
//             isIE = !1;
//             return !1
//         } else {
//             isIE = !0;
//             $('html').addClass('is-ie is-ie-' + rv);
//             return rv
//         }
//     }
//     var checkIOS = function() {
//         isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
//         return isIOS
//     }
//
//     function checkSafari() {
//         if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
//             isSafari = !0;
//             $('html').addClass('is-safari')
//         } else {
//             isSafari = !1
//         }
//         return isSafari
//     }
//     var simplifiedVersion = function() {
//         IEVersion = checkIE();
//         isIOS = checkIOS();
//         isSafari = checkSafari();
//         if (md.mobile() || (isIE && IEVersion < 10))
//             return !0;
//         else return !1
//     }
//     return {
//         init: init,
//         isDesktop: isDesktop,
//         isTablet: isTablet,
//         isSmartphone: isSmartphone,
//         isIOS: checkIOS,
//         isSafari: checkSafari,
//         isIE: checkIE,
//         simplifiedVersion: simplifiedVersion
//     }
// })(jQuery);
// var site = (function($) {
//     var isDev = !1;
//     var pageOpeningWait = !0;
//     var siteIsLoading = !0;
//     var pageSwitchBlocked = !1;
//     var globalLoader = $('.global-loader');
//     var currentURL = window.location.href;
//     var pageSlug = null;
//     var page = null;
//     var oldPage = null;
//     var ajaxNav = Modernizr.history;
//     var pagesData = [];
//     var linkTransition = !1;
//     var siteIntroDelay = 0;
//     var initTime = Date.now();
//     var canReveal = !1;
//     var windowWidth = 0;
//     var windowHeight = 0;
//     var scrollTop = 0;
//     var previousScrollTop = 0;
//     var init = function() {
//         tools.init();
//         nameChecker.init();
//         bindEvents();
//         pageSlug = $('.page-container').attr('data-page').toCamel();
//         page = window['page' + pageSlug];
//         savePagesData(window.location.href, document.documentElement.outerHTML);
//         pageInit();
//         contentLoading();
//         requestAnimationFrame(moveSmoothScroll);
//         initScrollParallax()
//     }
//     var historyStateChanged = function() {
//         var url = window.location.href;
//         pageLoading(url, !1)
//     }
//     var bindEvents = function() {
//         $('body').on('click', 'a', linkHandler);
//         $(window).on('resize orientationchange', resizeHandler);
//         $(window).on('scroll', {
//             passive: !0
//         }, scrollHandler);
//         $('.nav-toggle').on('click', navMainToggle);
//         $('body').on('reveal', '.scroll-reveal', scrollRevealHandler);
//         $('body').on('click', '.link-scrolldown', scrollDown)
//     }
//     var siteLoaded = function() {
//         resizeHandler();
//         siteIsLoading = !1
//     }
//     var resizeHandler = function() {
//         windowWidth = $(window).width();
//         if (windowHeight != window.innerHeight) {
//             var vh = window.innerHeight * 0.01;
//             document.documentElement.style.setProperty('--vh', vh + 'px');
//             windowHeight = window.innerHeight
//         }
//         scrollHandler();
//         if (!tools.simplifiedVersion())
//             resizeScrollParallax()
//     }
//     var scrollHandler = function() {
//         scrollTop = $(window).scrollTop();
//         if (canReveal) {
//             var revealLimit = windowHeight * 0.9 + scrollTop;
//             $('.scroll-reveal').not('.is-revealed').each(function() {
//                 var element = $(this);
//                 var top = element.offset().top - Number(element.css('marginTop').replace('px', ''));
//                 if (revealLimit >= top)
//                     element.trigger('reveal')
//             })
//         }
//         $('.lottie-loop').each(function() {
//             var element = $(this);
//             var offset = element.offset();
//             var lottieAnim = element.data('lottieAnim');
//             if (offset.top - scrollTop > windowHeight || offset.top + element.height() - scrollTop < 0) {
//                 if (!element.hasClass('is-paused') && lottieAnim != undefined)
//                     lottieAnim.pause();
//                 element.addClass('is-paused')
//             } else {
//                 if (element.hasClass('is-paused') && lottieAnim != undefined)
//                     lottieAnim.play();
//                 element.removeClass('is-paused')
//             }
//         });
//         var head = $('.site-head');
//         if (scrollTop > 0) {
//             head.addClass('is-small')
//         } else {
//             head.removeClass('is-small')
//         }
//         if (scrollTop > previousScrollTop) {
//             head.addClass('is-hidden')
//         } else {
//             head.removeClass('is-hidden')
//         }
//         previousScrollTop = scrollTop
//     }
//     var scrollDown = function(e) {
//         var toHeight = $(this).parent().height();
//         var maxHeight = $(document).height() - windowHeight;
//         toHeight = Math.min(toHeight, maxHeight);
//         TweenLite.to($('html,body'), 1, {
//             scrollTop: toHeight,
//             ease: Power3.easeInOut
//         });
//         e.preventDefault()
//     }
//     var linkHandler = function(e) {
//         var link = $(this);
//         if (!link.attr('href'))
//             return;
//         var url = link.attr('href').trimSlash();
//         if (url.indexOf(WRK.host) === 0) {
//             if (window.location.href.trimSlash() == url || link.parent().hasClass('no-transition'))
//                 return;
//             e.preventDefault();
//             var wait = $('.nav-main').data('wait');
//             if (wait)
//                 return;
//             var transition = link.data('transition');
//             if (transition != undefined)
//                 linkTransition = transition;
//             else linkTransition = !1;
//             link.trigger('loading');
//             pageLoading(url, !0);
//             if ($('.nav-main').hasClass('is-opened'))
//                 navMainToggle()
//         }
//     }
//     var showPreloader = function() {
//         var logo = globalLoader.find('.svg');
//         logo.css({
//             opacity: 0
//         });
//         if (isDev) {
//             siteLoaded()
//         } else {
//             $(window).on('load', siteLoaded)
//         }
//         var tl = new TimelineLite();
//         tl.pause();
//         tl.fromTo(logo, 1, {
//             alpha: 0,
//             y: 20,
//         }, {
//             alpha: 1,
//             y: 0,
//             ease: Power3.easeOut
//         }, 0);
//         tl.call(init);
//         tl.play()
//     }
//     var pageLoading = function(url, push) {
//         if (pageSwitchBlocked)
//             return;
//         pageSwitchBlocked = !0;
//         showLoader(function() {
//             var data = getPagesData(url);
//             if (data == undefined) {
//                 $.get(url, function(data) {
//                     savePagesData(url, data);
//                     pageCreate(data)
//                 }).fail(function() {
//                     window.location = '/404'
//                 })
//             } else {
//                 pageCreate(data)
//             }
//             if (push)
//                 history.pushState(null, null, url)
//         })
//     }
//     var pageCreate = function(data) {
//         canReveal = !1;
//         var html = $('<div/>').html(data);
//         var newContainer = html.find('.page-container');
//         newContainer.css({
//             opacity: 0,
//             position: 'absolute',
//             top: 0,
//             left: '-999em',
//             width: '100%'
//         });
//         newContainer.insertBefore('.page-container:first');
//         $('.site-head').attr('class', html.find('.site-head').attr('class'));
//         $('.global-container').attr('class', html.find('.global-container').attr('class'));
//         $('head meta').filter('[name="description"], [name="keywords"], [property="og:image"]').remove();
//         html.find('meta').filter('[name="description"], [name="keywords"], [property="og:image"]').insertAfter('head meta[name="viewport"]');
//         $('.menu-item').each(function() {
//             var item = $(this);
//             var newItem = html.find('#' + item.attr('id'));
//             item.attr('class', newItem.attr('class'))
//         });
//         $('head title').text(html.find('title').text());
//         var newPageSlug = newContainer.attr('data-page').toCamel();
//         oldPage = page;
//         page = window['page' + newPageSlug];
//         pageInit();
//         pageContentLoading()
//     }
//     var showLoader = function(callback) {
//         var loader = $('.page-loader');
//         var oldContainer = $('.page-container').last();
//         var tl = new TimelineLite();
//         tl.pause();
//         tl.to($('html,body'), 0.8, {
//             scrollTop: 0,
//             ease: Power3.easeInOut
//         }, 0);
//         tl.fromTo(oldContainer, 0.8, {
//             alpha: 1,
//             y: 0
//         }, {
//             alpha: 0,
//             y: 50,
//             ease: Power3.easeIn
//         }, 0);
//         tl.to(loader, 0.5, {
//             alpha: 1,
//             ease: Linear.easeNone
//         }, 0);
//         tl.call(function() {
//             loader.css({
//                 opacity: ''
//             });
//             loader.addClass('is-visible');
//             callback()
//         });
//         tl.play()
//     }
//     var hideLoader = function() {
//         var loader = $('.page-loader');
//         loader.css({
//             opacity: ''
//         });
//         loader.removeClass('is-visible')
//     }
//     var pageIntro = function() {
//         var newContainer = $('.page-container').first();
//         var oldContainer = $('.page-container').not(newContainer);
//         $(window).scrollTop(0);
//         newContainer.css({
//             left: 0,
//             opacity: 1
//         });
//         if (page != undefined && page.intro != undefined) {
//             page.intro()
//         } else {
//             pageSwitch()
//         }
//     }
//     var pageSwitch = function() {
//         if ($('.page-container').length > 1) {
//             var newContainer = $('.page-container').first();
//             var oldContainer = $('.page-container').not(newContainer);
//             newContainer.css({
//                 opacity: '',
//                 position: '',
//                 top: '',
//                 left: '',
//                 width: ''
//             });
//             oldContainer.css({
//                 opacity: 0,
//                 position: 'absolute',
//                 top: 0,
//                 left: '-999em',
//                 width: '100%'
//             });
//             pageKill()
//         } else {
//             $('.page-container').css({
//                 opacity: '',
//                 position: '',
//                 top: '',
//                 left: '',
//                 width: ''
//             })
//         }
//         canReveal = !0;
//         resizeHandler()
//     }
//     var pageInit = function() {
//         resizeHandler();
//         $('img.queue-loading').not('.is-loaded').queueLoading();
//         slider.init();
//         loadLottieAnimations();
//         if (page != undefined && page.init != undefined)
//             page.init()
//     }
//     var contentLoading = function() {
//         var siteLoaded = !siteIsLoading;
//         var pageLoaded = !0;
//         if (page != undefined && page.contentLoading != undefined)
//             pageLoaded = page.contentLoading();
//         if ($('.lottie-container').not('.is-loaded').length > 0)
//             siteLoaded = !1;
//         if (siteLoaded) {
//             var now = Date.now();
//             if (!isDev && (now - initTime) < siteIntroDelay)
//                 siteLoaded = !1
//         }
//         if ((isDev && siteLoaded) || (siteLoaded && pageLoaded)) {
//             intro()
//         } else {
//             setTimeout(contentLoading, 100)
//         }
//     }
//     var pageContentLoading = function() {
//         var pageLoaded = !0;
//         if (page != undefined && page.contentLoading != undefined)
//             pageLoaded = page.contentLoading();
//         if ($('.lottie-container.required').not('.is-loaded').length > 0)
//             pageLoaded = !1;
//         if ($('img.queue-loading').not('.is-loaded').length > 0)
//             pageLoaded = !1;
//         if (pageLoaded) {
//             setTimeout(function() {
//                 hideLoader();
//                 pageIntro()
//             }, 100)
//         } else {
//             setTimeout(pageContentLoading, 100)
//         }
//     }
//     var loadLottieAnimations = function() {
//         $('.lottie-container').each(function() {
//             var container = $(this);
//             var key = container.attr('data-key');
//             var anim = container.data('lottieAnim');
//             if (typeof(anim) == 'object')
//                 return;
//             if (container.hasClass('lottie-intro')) {
//                 let autoPlay = !1;
//                 if (container.attr('data-autoplay') == 'true')
//                     autoPlay = !0;
//                 anim = bodymovin.loadAnimation({
//                     container: this,
//                     renderer: 'svg',
//                     loop: !1,
//                     autoplay: autoPlay,
//                     path: WRK.tpl_dir + '/anim/' + key + '.json'
//                 });
//                 var containerLoop = container.next('.lottie-loop');
//                 if (containerLoop.length == 1) {
//                     containerLoop.addClass('is-hidden');
//                     anim.addEventListener('reset', function() {
//                         container.removeClass('is-hidden');
//                         containerLoop.addClass('is-hidden');
//                         anim.goToAndStop(0, !0);
//                         var animLoop = containerLoop.data('lottieAnim');
//                         if (animLoop != undefined)
//                             animLoop.goToAndStop(0, !0)
//                     });
//                     anim.addEventListener('complete', function() {
//                         if (tools.isSmartphone() && containerLoop.attr('data-mobile') != 'true') {
//                             anim.goToAndStop(anim.totalFrames - 1, !0)
//                         } else {
//                             container.addClass('is-hidden');
//                             containerLoop.removeClass('is-hidden');
//                             anim.goToAndStop(0, !0);
//                             var animLoop = containerLoop.data('lottieAnim');
//                             if (animLoop != undefined)
//                                 animLoop.goToAndPlay(0, !0)
//                         }
//                     })
//                 } else {
//                     anim.addEventListener('complete', function() {
//                         container.addClass('is-complete');
//                         anim.goToAndStop(anim.totalFrames - 1, !0)
//                     })
//                 }
//             } else if (container.hasClass('lottie-loop')) {
//                 var autoPlay = !1;
//                 if (container.attr('data-autoplay') == 'true')
//                     autoPlay = !0;
//                 if (tools.isSmartphone() && container.attr('data-mobile') != 'true') {
//                     container.addClass('is-loaded');
//                     return
//                 }
//                 anim = bodymovin.loadAnimation({
//                     container: this,
//                     renderer: 'svg',
//                     loop: !0,
//                     autoplay: autoPlay,
//                     path: WRK.tpl_dir + '/anim/' + key + '.json'
//                 })
//             }
//             anim.addEventListener('data_ready', function() {
//                 $(anim.wrapper).addClass('is-loaded')
//             });
//             var speed = container.attr('data-speed');
//             if (speed == undefined)
//                 speed = 1;
//             anim.setSpeed(speed);
//             container.data('lottieAnim', anim)
//         })
//     }
//     var intro = function() {
//         if (isDev) {
//             globalLoader.remove();
//             pageSwitch();
//             if (page != undefined && page.intro != undefined)
//                 page.intro()
//         } else {
//             var logo = $('.site-title .lottie-container');
//             var logoAnim = logo.data('lottieAnim');
//             var topItems = $('.nav-main .menu-top .menu-item');
//             var mainItems = $('.nav-main .menu .menu-item');
//             var tl = new TimelineLite();
//             tl.pause();
//             tl.to(globalLoader, 0.5, {
//                 alpha: 0
//             }, 0);
//             tl.call(function() {
//                 globalLoader.remove();
//                 pageSwitch();
//                 if (page != undefined && page.intro != undefined)
//                     page.intro();
//                 $(window).bind('popstate', historyStateChanged)
//             }, null, null, 0.5);
//             tl.staggerFromTo(topItems, 0.5, {
//                 alpha: 0,
//                 y: 10
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.1, 0.5);
//             tl.staggerFromTo(mainItems, 0.5, {
//                 alpha: 0,
//                 y: 10
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.1, 0.5);
//             tl.call(function() {
//                 logoAnim.play()
//             }, null, null, 0.5);
//             tl.play()
//         }
//     }
//     var fps = 240;
//     if (tools.isIE() !== !1)
//         fps = 30;
//     var now;
//     var then = Date.now();
//     var interval = 1000 / fps;
//     var delta;
//     var moveSmoothScroll = function() {
//         now = Date.now();
//         delta = now - then;
//         if (delta > interval) {
//             if (!smoothScrollPause) {
//                 var scrollTopMove = scrollTop;
//                 $('.scroll-parallax').each(function() {
//                     var element = $(this);
//                     var start = Number(element.attr('data-start'));
//                     var stop = Number(element.attr('data-stop'));
//                     var movement = Number(element.attr('data-movement'));
//                     var currentY = getTranslateY(element);
//                     if (scrollTopMove < start) {
//                         destY = 0.5
//                     } else if (scrollTopMove > stop) {
//                         destY = 1.5
//                     } else {
//                         destY = ((scrollTopMove - start) / (stop - start)) + 0.5
//                     }
//                     var percent = destY;
//                     if (element.hasClass('image')) {
//                         var gap = Number(element.attr('data-gap'));
//                         destY -= 0.5;
//                         destY = gap * destY
//                     } else {
//                         destY = movement - movement * destY
//                     }
//                     if (Math.round(currentY) == Math.round(destY)) {
//                         return
//                     }
//                     if (scrollTopMove < start || scrollTopMove > stop) {
//                         element.css({
//                             transform: 'translate3d(0, ' + (destY) + 'px, 0)'
//                         });
//                         return
//                     }
//                     var newY = currentY + ((destY - currentY) * 0.1);
//                     element.css({
//                         transform: 'translate3d(0, ' + (newY) + 'px, 0)'
//                     })
//                 })
//             }
//             then = now - (delta % interval)
//         }
//         requestAnimationFrame(moveSmoothScroll)
//     }
//     var smoothScrollPause = !1;
//     var setSmoothScroll = function(state) {
//         if (state == 'pause')
//             smoothScrollPause = !0;
//         else smoothScrollPause = !1
//     }
//     var initScrollParallax = function() {
//         var scrollElements = $('.scroll-parallax');
//         scrollElements.each(function() {
//             var level = $(this).attr('data-level');
//             if (level == undefined) {
//                 level = $(this).css('zIndex');
//                 if (level == 'auto')
//                     level = 1;
//                 if (level > 5)
//                     level = 5;
//                 $(this).attr('data-level', level)
//             } else if (level == 'rand') {
//                 level = Math.random();
//                 $(this).attr('data-level', level)
//             }
//         });
//         resizeScrollParallax()
//     };
//     var resizeScrollParallax = function() {
//         $('.scroll-parallax').each(function() {
//             var element = $(this);
//             var level = Number(element.attr('data-level'));
//             var transform = element.css('transform');
//             element.css({
//                 transform: ''
//             });
//             element.attr('data-top', element.offset().top);
//             element.attr('data-movement', element.height() * level);
//             element.attr('data-start', element.offset().top - windowHeight);
//             element.attr('data-stop', element.offset().top + element.height());
//             if (element.hasClass('image')) {
//                 element.attr('data-gap', element.parent().height() - element.height())
//             }
//             element.css({
//                 transform: transform
//             })
//         })
//     };
//     var scrollRevealHandler = function() {
//         let element = $(this);
//         if (element.hasClass('is-revealed'))
//             return;
//         if (element.attr('data-reveal') == 'home-hero') {
//             let illustration = element.find('.illustration');
//             let title = element.find('.title');
//             let text = element.find('.text');
//             let form = element.find('.name-checker');
//             let formElements = form.find('.input, .button');
//             let formButton = form.find('.button');
//             let formButtonLabel = formButton.find('.label');
//             let formMask = form.find('.mask');
//             let formLines = form.find('.info .line');
//             let link = element.find('.link-scrolldown');
//             let lottieContainer = element.find('.lottie-container');
//             let lottieAnim = lottieContainer.data('lottieAnim');
//             let clouds = element.find('.clouds svg');
//             let st1 = new SplitText(title, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = title.find('.line');
//             formElements.css({
//                 opacity: 0
//             });
//             formButtonLabel.css({
//                 transition: 'none'
//             });
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(illustration, 0.8, {
//                 alpha: 0
//             }, 0.6);
//             tl.call(function() {
//                 lottieAnim.play()
//             }, null, null, 0.6);
//             tl.staggerFromTo(clouds, 0.5, {
//                 scale: 0
//             }, {
//                 scale: 1,
//                 ease: Back.easeOut
//             }, 0.1, 2);
//             tl.staggerFromTo(lines, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.fromTo(text, 0.8, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.85);
//             tl.fromTo(formMask, 1, {
//                 width: 0
//             }, {
//                 width: '100%',
//                 ease: Power3.easeIn
//             }, 0.25);
//             tl.call(function() {
//                 formElements.css({
//                     opacity: ''
//                 });
//                 formMask.css({
//                     left: 'auto',
//                     right: 0
//                 })
//             }, null, null, 1.25);
//             tl.to(formMask, 1, {
//                 width: formButton.outerWidth(),
//                 ease: Power3.easeOut
//             }, 1.25);
//             tl.call(function() {
//                 formMask.css({
//                     left: '',
//                     right: '',
//                     width: ''
//                 })
//             }, null, null, 2.25);
//             tl.fromTo(formButtonLabel, 0.5, {
//                 alpha: 0,
//                 x: -20
//             }, {
//                 alpha: 1,
//                 x: 0,
//                 ease: Power3.easeOut
//             }, 1.55);
//             tl.staggerFrom(formLines, 0.5, {
//                 alpha: 0,
//                 x: -20,
//                 ease: Power3.easeOut
//             }, 0.1, 1.35);
//             tl.from(link, 0.8, {
//                 height: 0,
//                 ease: Power3.easeOut
//             }, 1.5);
//             tl.call(function() {
//                 st1.revert();
//                 illustration.css({
//                     opacity: ''
//                 });
//                 lines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 text.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 formLines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 formButtonLabel.css({
//                     opacity: '',
//                     transform: '',
//                     transition: ''
//                 });
//                 link.css({
//                     height: ''
//                 });
//                 clouds.css({
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'home-quote') {
//             let text = element.find('.quote p');
//             let marks = element.find('.quote .mark');
//             let shape = element.find('.shape');
//             let shapeRect = shape.find('.rect');
//             let shapeArc = shape.find('.arc');
//             let shapeArcMask = shapeArc.find('.mask');
//             let circles = element.find('.circle');
//             let st1 = new SplitText(text, {type: 'lines', linesClass: 'line' });
//             let lines = text.find('.line');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(shapeRect, 0.8, {
//                 scaleX: 0,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.fromTo(shapeArcMask, 1.5, {
//                 alpha: 1,
//                 rotationZ: 0
//             }, {
//                 alpha: 1,
//                 rotationZ: -180,
//                 ease: Power3.easeOut
//             }, 0.8);
//             tl.from(circles, 0.5, {
//                 alpha: 0
//             }, 0.5);
//             tl.staggerFromTo(lines.add(marks), 0.8, { alpha: 0,  y: 50 }, { alpha: 1, y: 0, }, 0.2, 1.2);
//             tl.call(function() {
//                 st1.revert();
//                 text.add(marks).css({
//                     transform: '',
//                     opacity: ''
//                 });
//                 circles.css({
//                     opacity: ''
//                 });
//                 shapeRect.css({
//                     transform: ''
//                 });
//                 shapeArc.css({
//                     transform: '',
//                     opacity: ''
//                 });
//                 shapeArcMask.css({
//                     transform: '',
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'home-rtb') {
//             let reasons = element.find('.reason');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             let reasonStart = 0.2;
//             reasons.each(function() {
//                 let reason = $(this);
//                 let lottieContainer = reason.find('.lottie-container');
//                 let lottieAnim = lottieContainer.data('lottieAnim');
//                 tl.staggerFromTo(reason.find('.label, .text'), 0.8, {
//                     alpha: 0,
//                     y: 50
//                 }, {
//                     alpha: 1,
//                     y: 0,
//                     ease: Power3.easeOut
//                 }, 0.1, reasonStart);
//                 tl.from(lottieContainer, 0.3, {
//                     alpha: 0,
//                     clearProps: 'opacity'
//                 }, reasonStart + 0.2);
//                 tl.call(function() {
//                     lottieAnim.play()
//                 }, null, null, reasonStart + 0.2);
//                 reasonStart += 0.2
//             });
//             tl.call(function() {
//                 reasons.find('.label, .text, .icon').css({
//                     transform: '',
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'svg-shape-1') {
//             let paths = element.find('path');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.staggerFromTo(paths.reverse(), 1, {
//                 xPercent: 100
//             }, {
//                 xPercent: 0,
//                 ease: Power3.easeOut
//             }, 0.3, 0.5);
//             tl.play()
//         } else if (element.attr('data-reveal') == 'home-services') {
//             let background = element.find('.background');
//             let title = element.find('.title');
//             let text = element.find('.text, .btn-plain');
//             let lottieContainer = element.find('.lottie-container');
//             let lottieAnim = lottieContainer.data('lottieAnim');
//             let st1 = new SplitText(title, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = title.find('.line');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(background, 1.2, {
//                 scaleX: 0,
//                 ease: Power3.easeInOut
//             }, 0);
//             tl.call(function() {
//                 lottieAnim.play()
//             }, null, null, 0.8);
//             tl.staggerFromTo(lines, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0.8);
//             tl.staggerFromTo(text, 0.8, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 1.45);
//             tl.call(function() {
//                 st1.revert();
//                 background.css({
//                     transform: ''
//                 });
//                 lines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 text.css({
//                     opacity: '',
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'home-process') {
//             let text = element.find('.title-section, .intro');
//             let pages = element.find('.page');
//             let content = element.find('.slide.is-active .content');
//             let illustration = element.find('.slide.is-active .illustration');
//             let lottieAnim = illustration.find('.lottie-intro').data('lottieAnim');
//             let background = element.find('.svg-home-step-background');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.staggerFromTo(text, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.call(function() {
//                 lottieAnim.play()
//             }, null, null, 0.5);
//             tl.from(background, 0.5, {
//                 alpha: 0
//             }, 0.5);
//             tl.fromTo(content, 0.3, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.8);
//             tl.fromTo(content.find('.line'), 0.3, {
//                 scaleX: 0
//             }, {
//                 scaleX: 1,
//                 ease: Power3.easeInOut
//             }, 0.8);
//             tl.staggerFromTo(pages, 0.5, {
//                 alpha: 0,
//                 left: -20
//             }, {
//                 alpha: 1,
//                 left: 0,
//                 ease: Power3.easeOut
//             }, 0.1, 0.8);
//             tl.call(function() {
//                 background.css({
//                     opacity: ''
//                 });
//                 illustration.css({
//                     opacity: ''
//                 });
//                 content.css({
//                     transform: '',
//                     opacity: ''
//                 });
//                 content.find('.line').css({
//                     transform: ''
//                 });
//                 pages.css({
//                     left: '',
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'services-hero') {
//             let title = element.find('.title');
//             let text = element.find('.text');
//             let clouds = element.find('.clouds svg');
//             let shape = element.find('.shape');
//             let st1 = new SplitText(title, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = title.find('.line');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(shape, 0.5, {
//                 alpha: 0
//             }, 0);
//             tl.staggerFromTo(lines.add(text), 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.staggerFromTo(clouds, 0.5, {
//                 scale: 0
//             }, {
//                 scale: 1,
//                 ease: Back.easeOut
//             }, 0.1, 0.4);
//             tl.call(function() {
//                 st1.revert();
//                 shape.css({
//                     opacity: ''
//                 });
//                 lines.add(text).css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 clouds.css({
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'services-service') {
//             let elements = element.find('.title, li');
//             let lottieContainer = element.find('.lottie-container');
//             let lottieAnim = lottieContainer.data('lottieAnim');
//             let clouds = element.find('.clouds svg');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.staggerFromTo(elements, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.from(lottieContainer, 0.3, {
//                 alpha: 0
//             }, 0);
//             tl.staggerFromTo(clouds, 0.5, {
//                 scale: 0
//             }, {
//                 scale: 1,
//                 ease: Back.easeOut
//             }, 0.1, 1.4);
//             tl.call(function() {
//                 lottieAnim.play()
//             }, null, null, 0);
//             tl.call(function() {
//                 lottieContainer.css({
//                     opacity: ''
//                 });
//                 elements.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 clouds.css({
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'services-additional') {
//             let background = element.find('.background');
//             let illustration = element.find('.illustration');
//             let header = element.find('.header-section > *');
//             let iconLines = header.find('.line');
//             let services = element.find('.service');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(background, 1.2, {
//                 scaleX: 0,
//                 ease: Power3.easeInOut
//             }, 0);
//             tl.staggerFromTo(header, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0.8);
//             tl.fromTo(iconLines.eq(0), 0.5, {
//                 scaleY: 0,
//                 y: -20
//             }, {
//                 scaleY: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 1.2);
//             tl.fromTo(iconLines.eq(1), 0.5, {
//                 scaleX: 0,
//                 x: -20
//             }, {
//                 scaleX: 1,
//                 x: 0,
//                 ease: Power3.easeOut
//             }, 1.3);
//             let servicesStart = 1.2;
//             services.each(function() {
//                 let service = $(this);
//                 let lottieContainer = service.find('.lottie-container');
//                 let lottieAnim = lottieContainer.data('lottieAnim');
//                 tl.staggerFromTo(service.find('.label, .text'), 0.8, {
//                     alpha: 0,
//                     y: 50
//                 }, {
//                     alpha: 1,
//                     y: 0,
//                     ease: Power3.easeOut
//                 }, 0.1, servicesStart);
//                 tl.from(lottieContainer, 0.3, {
//                     alpha: 0,
//                     clearProps: 'opacity'
//                 }, servicesStart + 0.2);
//                 tl.call(function() {
//                     lottieAnim.play()
//                 }, null, null, servicesStart + 0.2);
//                 servicesStart += 0.2
//             });
//             tl.call(function() {
//                 background.css({
//                     width: ''
//                 });
//                 header.css({
//                     opacity: ''
//                 });
//                 iconLines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 services.find('.label, .text, .lottie-container').css({
//                     opacity: '',
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'page-header') {
//             let title = element.find('.title');
//             let text = element.find('.text');
//             let clouds = element.find('.clouds svg');
//             let st1 = new SplitText(title, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = title.find('.line');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.staggerFromTo(lines.add(text), 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.staggerFromTo(clouds, 0.5, {
//                 scale: 0
//             }, {
//                 scale: 1,
//                 ease: Back.easeOut
//             }, 0.1, 0.4);
//             tl.call(function() {
//                 st1.revert();
//                 lines.add(text).css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 clouds.css({
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'section-text') {
//             let dropcap = element.find('.dropcap');
//             let text = element.find('> *');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(text, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0);
//             tl.call(function() {
//                 dropcap.addClass('is-visible')
//             }, null, null, 0.3);
//             tl.call(function() {
//                 text.css({
//                     opacity: '',
//                     transform: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'section-image') {
//             let image = element.find('.image');
//             let masks = element.find('.mask');
//             image.css({
//                 opacity: 0
//             });
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(masks.filter('.top'), 0.8, {
//                 alpha: 1,
//                 x: 100,
//                 scaleX: 0
//             }, {
//                 alpha: 1,
//                 x: 0,
//                 scaleX: 1,
//                 immediateRender: !1,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.fromTo(masks.filter('.bottom'), 0.8, {
//                 alpha: 1,
//                 x: -100,
//                 scaleX: 0
//             }, {
//                 alpha: 1,
//                 x: 0,
//                 scaleX: 1,
//                 immediateRender: !1,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.call(function() {
//                 masks.filter('.top').css({
//                     transformOrigin: '0 0'
//                 });
//                 masks.filter('.bottom').css({
//                     transformOrigin: '100% 0'
//                 });
//                 image.css({
//                     opacity: ''
//                 })
//             });
//             tl.fromTo(masks.filter('.top'), 0.8, {
//                 x: 0,
//                 scaleX: 1
//             }, {
//                 x: -100,
//                 scaleX: 0,
//                 immediateRender: !1,
//                 ease: Power3.easeOut
//             }, 0.8);
//             tl.fromTo(masks.filter('.bottom'), 0.8, {
//                 x: 0,
//                 scaleX: 1
//             }, {
//                 x: 100,
//                 scaleX: 0,
//                 immediateRender: !1,
//                 ease: Power3.easeOut
//             }, 0.8);
//             tl.call(function() {
//                 masks.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 image.css({
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'section-quote') {
//             let text = element.find('.quote .text');
//             let marks = element.find('.quote .mark');
//             let shape = element.find('.shape');
//             let shapeRect = shape.find('.rect');
//             let shapeArc = shape.find('.arc');
//             let shapeArcMask = shapeArc.find('.mask');
//             let circle = element.find('.circle');
//             let st1 = new SplitText(text, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = text.find('.line');
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.from(shapeRect, 0.8, {
//                 scaleX: 0,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.fromTo(shapeArcMask, 1.5, {
//                 alpha: 1,
//                 rotationZ: 0
//             }, {
//                 alpha: 1,
//                 rotationZ: -180,
//                 ease: Power3.easeOut
//             }, 0.8);
//             tl.from(circle, 0.5, {
//                 alpha: 0
//             }, 0.5);
//             tl.staggerFromTo(lines.add(marks), 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 1.2);
//             tl.call(function() {
//                 st1.revert();
//                 text.add(marks).css({
//                     transform: '',
//                     opacity: ''
//                 });
//                 circle.css({
//                     opacity: ''
//                 });
//                 shapeRect.css({
//                     transform: ''
//                 });
//                 shapeArc.css({
//                     transform: '',
//                     opacity: ''
//                 });
//                 shapeArcMask.css({
//                     transform: '',
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'fade') {
//             element.css({
//                 opacity: 0
//             });
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(element, 0.5, {
//                 alpha: 0
//             }, {
//                 alpha: 1
//             });
//             tl.call(function() {
//                 element.css({
//                     opacity: ''
//                 })
//             });
//             tl.play()
//         } else if (element.attr('data-reveal') == 'name-checker') {
//             let illustration = element.find('.illustration');
//             let title = element.find('.title');
//             let text = element.find('.text');
//             let form = element.find('.name-checker');
//             let formElements = form.find('.input, .button');
//             let formButton = form.find('.button');
//             let formButtonLabel = formButton.find('.label');
//             let formMask = form.find('.mask');
//             let formLines = form.find('.info .line');
//             let paths = element.find('.svg-shape-1 path');
//             let st1 = new SplitText(title, {
//                 type: 'lines',
//                 linesClass: 'line'
//             });
//             let lines = title.find('.line');
//             formElements.css({
//                 opacity: 0
//             });
//             formButtonLabel.css({
//                 transition: 'none'
//             });
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.staggerFromTo(paths.reverse(), 1, {
//                 xPercent: 100
//             }, {
//                 xPercent: 0,
//                 ease: Power3.easeOut
//             }, 0.3, 0);
//             tl.staggerFromTo(lines, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.2, 0);
//             tl.fromTo(text, 0.8, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.65);
//             tl.fromTo(formMask, 1, {
//                 width: 0
//             }, {
//                 width: '100%',
//                 ease: Power3.easeIn
//             }, 0.05);
//             tl.call(function() {
//                 formElements.css({
//                     opacity: ''
//                 });
//                 formMask.css({
//                     left: 'auto',
//                     right: 0
//                 })
//             }, null, null, 1.05);
//             tl.to(formMask, 1, {
//                 width: formButton.outerWidth(),
//                 ease: Power3.easeOut
//             }, 1.05);
//             tl.call(function() {
//                 formMask.css({
//                     left: '',
//                     right: '',
//                     width: ''
//                 })
//             }, null, null, 2.05);
//             tl.fromTo(formButtonLabel, 0.5, {
//                 alpha: 0,
//                 x: -20
//             }, {
//                 alpha: 1,
//                 x: 0,
//                 ease: Power3.easeOut
//             }, 1.35);
//             tl.staggerFrom(formLines, 0.5, {
//                 alpha: 0,
//                 x: -20,
//                 ease: Power3.easeOut
//             }, 0.1, 1.15);
//             tl.call(function() {
//                 st1.revert();
//                 lines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 text.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 formLines.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 formButtonLabel.css({
//                     opacity: '',
//                     transform: '',
//                     transition: ''
//                 })
//             });
//             tl.play()
//         } else {
//             element.css({
//                 opacity: 0
//             });
//             element.addClass('is-revealed');
//             let tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(element, 0.8, {
//                 alpha: 0,
//                 y: 50
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0);
//             tl.call(function() {
//                 element.css({
//                     opacity: '',
//                     transform: ''
//                 })
//             });
//             tl.play()
//         }
//     };
//     var pageKill = function() {
//         var newContainer = $('.page-container').first();
//         var oldContainer = $('.page-container').not(newContainer);
//         oldContainer.find('.lottie-container').each(function() {
//             var lottieAnim = $(this).data('lottieAnim');
//             if (lottieAnim && lottieAnim != undefined && lottieAnim != null)
//                 lottieAnim.destroy()
//         });
//         if (oldPage != undefined && oldPage.kill != undefined) {
//             oldPage.kill()
//         } else {
//             oldContainer.remove()
//         }
//         pageSwitchBlocked = !1
//     }
//     var getPage = function() {
//         return page
//     }
//     var savePagesData = function(url, data) {
//         url = url.replace(/\/$/, "");
//         pagesData[url] = data
//     }
//     var getPagesData = function(url) {
//         url = url.replace(/\/$/, "");
//         return pagesData[url]
//     }
//     var navMainToggle = function() {
//         var nav = $('.nav-main');
//         var container = nav.find('.nav-container');
//         var mask = nav.find('.mask');
//         var mainItems = nav.find('.menu .menu-item');
//         var menuTop = nav.find('.menu-top');
//         var wait = nav.data('wait');
//         if (wait)
//             return;
//         nav.data('wait', !0);
//         if (nav.hasClass('is-opened')) {
//             container.css({
//                 opacity: 1
//             });
//             tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(mask, 0.5, {
//                 scaleX: 0
//             }, {
//                 scaleX: 1,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.call(function() {
//                 nav.removeClass('is-opened')
//             }, null, null, 0.5);
//             tl.fromTo(container, 0.5, {
//                 x: 0
//             }, {
//                 x: windowWidth,
//                 ease: Power3.easeOut
//             }, 0.5);
//             tl.call(function() {
//                 container.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 mask.css({
//                     transform: ''
//                 });
//                 nav.data('wait', !1)
//             });
//             tl.play()
//         } else {
//             container.css({
//                 opacity: 1
//             });
//             tl = new TimelineLite();
//             tl.pause();
//             tl.fromTo(container, 0.5, {
//                 x: windowWidth
//             }, {
//                 x: 0,
//                 ease: Power3.easeIn
//             }, 0);
//             tl.fromTo(mask, 0.5, {
//                 scaleX: 1
//             }, {
//                 scaleX: 0,
//                 ease: Power3.easeOut
//             }, 0.5);
//             tl.call(function() {
//                 nav.addClass('is-opened')
//             }, null, null, 0.5);
//             tl.staggerFromTo(mainItems, 0.5, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 0.1, 0.6);
//             tl.fromTo(menuTop, 0.5, {
//                 alpha: 0,
//                 y: 20
//             }, {
//                 alpha: 1,
//                 y: 0,
//                 ease: Power3.easeOut
//             }, 1);
//             tl.call(function() {
//                 container.css({
//                     opacity: '',
//                     transform: ''
//                 });
//                 mask.css({
//                     transform: ''
//                 });
//                 mainItems.css({
//                     oapcity: '',
//                     transform: ''
//                 });
//                 menuTop.css({
//                     oapcity: '',
//                     transform: ''
//                 });
//                 nav.data('wait', !1)
//             });
//             tl.play()
//         }
//     }
//     return {
//         init: init,
//         showPreloader: showPreloader,
//         hideLoader: hideLoader,
//         pageSwitch: pageSwitch,
//         pageLoading: pageLoading
//     }
// })(jQuery);
// var pageContact = (function($) {
//     var pageSlug = 'contact';
//     var pageContainer = null;
//     var init = function() {
//         pageContainer = $('.page-container[data-page="' + pageSlug + '"]').first();
//         bindEvents();
//         pageContainer.find('.content, .map-container').css({
//             opacity: 0
//         });
//         if (!$('body').hasClass('has-ggmap')) {
//             var mapContainer = pageContainer.find('.ggmap');
//             var script = $('<script src="' + mapContainer.attr('data-script-url') + '&callback=googleMapCallback"></script>');
//             script.insertAfter(mapContainer)
//         } else {
//             googleMapCallback()
//         }
//     }
//     var bindEvents = function() {
//         $(window).on('resize orientationchange', resizeMap)
//     }
//     var unbindEvents = function() {
//         $(window).off('resize orientationchange', resizeMap);
//         var mapContainer = pageContainer.find('.ggmap');
//         var map = mapContainer.data('map');
//         google.maps.event.clearListeners(map)
//     }
//     var contentLoading = function() {
//         return $('.ggmap').hasClass('is-loaded')
//     }
//     var initMap = function() {
//         var styles = [{
//             "featureType": "all",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "off"
//             }]
//         }, {
//             "featureType": "all",
//             "elementType": "geometry.fill",
//             "stylers": [{
//                 "visibility": "on"
//             }, {
//                 "hue": "#ff0000"
//             }]
//         }, {
//             "featureType": "administrative",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "off"
//             }, {
//                 "hue": "#00ffc6"
//             }, {
//                 "gamma": "1.67"
//             }]
//         }, {
//             "featureType": "administrative",
//             "elementType": "labels.text.fill",
//             "stylers": [{
//                 "color": "#444444"
//             }]
//         }, {
//             "featureType": "administrative.country",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "on"
//             }]
//         }, {
//             "featureType": "administrative.province",
//             "elementType": "geometry",
//             "stylers": [{
//                 "visibility": "on"
//             }]
//         }, {
//             "featureType": "administrative.land_parcel",
//             "elementType": "labels",
//             "stylers": [{
//                 "visibility": "on"
//             }]
//         }, {
//             "featureType": "landscape",
//             "elementType": "all",
//             "stylers": [{
//                 "color": "#ffffff"
//             }, {
//                 "visibility": "simplified"
//             }]
//         }, {
//             "featureType": "landscape.natural",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "simplified"
//             }]
//         }, {
//             "featureType": "poi",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "off"
//             }]
//         }, {
//             "featureType": "road",
//             "elementType": "all",
//             "stylers": [{
//                 "saturation": -100
//             }, {
//                 "lightness": 45
//             }, {
//                 "visibility": "simplified"
//             }]
//         }, {
//             "featureType": "road.highway",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "simplified"
//             }]
//         }, {
//             "featureType": "road.arterial",
//             "elementType": "labels.icon",
//             "stylers": [{
//                 "visibility": "off"
//             }]
//         }, {
//             "featureType": "transit",
//             "elementType": "all",
//             "stylers": [{
//                 "visibility": "off"
//             }]
//         }, {
//             "featureType": "water",
//             "elementType": "all",
//             "stylers": [{
//                 "color": "#eaecef"
//             }, {
//                 "visibility": "on"
//             }]
//         }];
//         var mapContainer = pageContainer.find('.ggmap');
//         var mapCenter = new google.maps.LatLng(mapContainer.attr('data-lat'), mapContainer.attr('data-lng'));
//         var mapOptions = {
//             backgroundColor: '#fff',
//             center: mapCenter,
//             zoom: 15,
//             styles: styles,
//             streetViewControl: !1,
//             mapTypeControl: !1,
//             scrollwheel: !1,
//         };
//         var map = new google.maps.Map(mapContainer.get(0), mapOptions);
//         var marker = new google.maps.Marker({
//             position: mapCenter,
//             map: map,
//             icon: {
//                 url: '/wp-content/themes/caxis/img/map-marker.svg',
//                 size: new google.maps.Size(40, 52),
//                 scaledSize: new google.maps.Size(40, 52),
//                 origin: new google.maps.Point(0, 0),
//                 anchor: new google.maps.Point(40, 26)
//             }
//         });
//         marker.addListener('click', function() {
//             var link = mapContainer.attr('data-link');
//             if (link != '')
//                 window.open(link)
//         });
//         google.maps.event.addListenerOnce(map, 'idle', function() {
//             $('.ggmap').addClass('is-loaded')
//         });
//         mapContainer.data('map', map);
//         mapContainer.data('mapCenter', mapCenter);
//         mapContainer.data('marker', marker);
//         resizeMap()
//     }
//     var addMarker = function() {
//         var mapContainer = pageContainer.find('.ggmap');
//         var map = mapContainer.data('map');
//         var mapCenter = mapContainer.data('mapCenter');
//         var marker = new google.maps.Marker({
//             position: mapCenter,
//             map: map,
//             icon: {
//                 url: '/wp-content/themes/caxis/img/map-marker.svg',
//                 size: new google.maps.Size(40, 52),
//                 scaledSize: new google.maps.Size(40, 52),
//                 origin: new google.maps.Point(0, 0),
//                 anchor: new google.maps.Point(40, 26)
//             }
//         });
//         marker.addListener('click', function() {
//             var link = mapContainer.attr('data-link');
//             if (link != '')
//                 window.open(link)
//         });
//         mapContainer.data('marker', marker)
//     }
//     var intro = function() {
//         var elements = pageContainer.find('.content, .map-container');
//         var masks = pageContainer.find('.mask');
//         var texts = pageContainer.find('.content .title, .content .contact, .content .address, .content .link');
//         var tl = new TimelineLite();
//         tl.pause();
//         tl.fromTo(masks.filter('.top'), 0.8, {
//             alpha: 1,
//             x: 100,
//             scaleX: 0
//         }, {
//             alpha: 1,
//             x: 0,
//             scaleX: 1,
//             immediateRender: !1,
//             ease: Power3.easeIn
//         }, 0);
//         tl.fromTo(masks.filter('.bottom'), 0.8, {
//             alpha: 1,
//             x: -100,
//             scaleX: 0
//         }, {
//             alpha: 1,
//             x: 0,
//             scaleX: 1,
//             immediateRender: !1,
//             ease: Power3.easeIn
//         }, 0);
//         tl.call(function() {
//             masks.filter('.top').css({
//                 transformOrigin: '0 0'
//             });
//             masks.filter('.bottom').css({
//                 transformOrigin: '100% 0'
//             });
//             elements.css({
//                 opacity: ''
//             })
//         });
//         tl.fromTo(masks.filter('.top'), 0.8, {
//             x: 0,
//             scaleX: 1
//         }, {
//             x: -100,
//             scaleX: 0,
//             immediateRender: !1,
//             ease: Power3.easeOut
//         }, 0.8);
//         tl.fromTo(masks.filter('.bottom'), 0.8, {
//             x: 0,
//             scaleX: 1
//         }, {
//             x: 100,
//             scaleX: 0,
//             immediateRender: !1,
//             ease: Power3.easeOut
//         }, 0.8);
//         tl.staggerFromTo(texts, 0.5, {
//             alpha: 0,
//             y: 20
//         }, {
//             alpha: 1,
//             y: 0,
//             ease: Power3.easeOut
//         }, 0.1, 1);
//         tl.call(function() {
//             masks.css({
//                 opacity: '',
//                 transform: ''
//             });
//             texts.css({
//                 opacity: '',
//                 transform: ''
//             });
//             site.pageSwitch()
//         });
//         tl.play()
//     }
//     var resizeMap = function() {
//         var mapContainer = pageContainer.find('.ggmap');
//         var map = mapContainer.data('map');
//         if (typeof(map) == 'undefined')
//             return;
//         var mapCenter = mapContainer.data('mapCenter');
//         map.setCenter(mapCenter);
//         google.maps.event.trigger(map, 'resize')
//     }
//     var kill = function() {
//         var mapContainer = pageContainer.find('.ggmap');
//         var map = mapContainer.data('map');
//         var mapCenter = mapContainer.data('mapCenter');
//         var marker = mapContainer.data('marker');
//         map = null;
//         mapCenter = null;
//         marker.setMap(null);
//         marker = null;
//         mapContainer.data('map', '');
//         mapContainer.data('mapCenter', '');
//         mapContainer.data('marker', '');
//         unbindEvents();
//         $('.page-container').last().remove()
//     }
//     return {
//         init: init,
//         kill: kill,
//         intro: intro,
//         pageSlug: pageSlug,
//         pageContainer: pageContainer,
//         contentLoading: contentLoading,
//         initMap: initMap
//     }
// })(jQuery);
// var slider = (function($) {
//     var init = function() {
//         var pageContainer = $('.page-container').first();
//         var sliders = pageContainer.find('.slider');
//         sliders.each(function() {
//             var slider = $(this);
//             slider.swipe({
//                 swipeLeft: function() {
//                     nextSlide($(this), !1)
//                 },
//                 swipeRight: function() {
//                     nextSlide($(this), !0)
//                 },
//                 preventDefaultEvents: !tools.isIOS()
//             });
//             slider.on('click', '.pagination .page', paginationClick)
//         })
//     }
//     var switchSlides = function(slider, index) {
//         if (slider.data('wait'))
//             return;
//         var container = slider.find('.slides');
//         var slides = slider.find('.slide');
//         var activeSlide = slides.filter('.is-active');
//         var activeIllustration = activeSlide.find('.illustration');
//         var activeContent = activeSlide.find('.content');
//         var activeAnim = activeIllustration.find('.lottie-intro').data('lottieAnim');
//         var newSlide = slides.eq(index);
//         var newContent = newSlide.find('.content');
//         var newIllustration = newSlide.find('.illustration');
//         var newAnim = newIllustration.find('.lottie-intro').data('lottieAnim');
//         var pages = slider.find('.pagination .page');
//         if (newSlide.is(activeSlide))
//             return;
//         newSlide.css({
//             opacity: 1
//         });
//         slider.data('wait', !0);
//         var tl = new TimelineLite();
//         tl.pause();
//         tl.fromTo(activeContent, 0.3, {
//             alpha: 1,
//             y: 0
//         }, {
//             alpha: 0,
//             y: -20,
//             ease: Power3.easeIn
//         }, 0);
//         tl.to(activeIllustration, 0.3, {
//             alpha: 0
//         }, 0);
//         tl.fromTo(newContent, 0.3, {
//             alpha: 0,
//             y: 20
//         }, {
//             alpha: 1,
//             y: 0,
//             ease: Power3.easeOut
//         }, 0.3);
//         tl.fromTo(newContent.find('.line'), 0.3, {
//             scaleX: 0
//         }, {
//             scaleX: 1,
//             ease: Power3.easeInOut
//         }, 0.3);
//         tl.call(function() {
//             newAnim.play()
//         }, null, null, 0.3);
//         tl.call(function() {
//             activeContent.css({
//                 transform: '',
//                 opacity: ''
//             });
//             activeIllustration.css({
//                 opacity: ''
//             });
//             newContent.css({
//                 transform: '',
//                 opacity: ''
//             });
//             newContent.find('.line').css({
//                 transform: ''
//             });
//             newSlide.css({
//                 opacity: ''
//             });
//             activeAnim.trigger('reset');
//             newSlide.addClass('is-active');
//             activeSlide.removeClass('is-active');
//             slider.data('wait', !1)
//         });
//         tl.play();
//         pages.removeClass('is-active');
//         pages.eq(newSlide.index()).addClass('is-active')
//     }
//     var nextSlide = function(slider, previous) {
//         var slides = slider.find('.slide');
//         var activeSlide = slides.filter('.is-active');
//         var newSlide = null;
//         if (previous) {
//             newSlide = activeSlide.prev('.slide');
//             if (newSlide.length == 0)
//                 newSlide = slides.last()
//         } else {
//             newSlide = activeSlide.next('.slide');
//             if (newSlide.length == 0)
//                 newSlide = slides.filter('.slide').first()
//         }
//         switchSlides(slider, newSlide.index())
//     }
//     var navigationClick = function() {
//         nextSlide($(this).closest('.slider'), $(this).hasClass('prev'))
//     }
//     var paginationClick = function() {
//         var page = $(this);
//         var slider = page.closest('.slider');
//         switchSlides(slider, page.index())
//     }
//     return {
//         init: init
//     }
// })(jQuery);
// var nameChecker = (function($) {
//     var init = function() {
//         $('body').on('keypress', '.name-checker .input', inputPress);
//         $('body').on('submit', '.name-checker', checkName)
//     }
//     var inputPress = function() {
//         var input = $(this);
//         var toBorderColor = '';
//         if (input.attr('data-border') !== undefined) {
//             toBorderColor = input.attr('data-border')
//         } else {
//             toBorderColor = $(this).css('border-color');
//             input.attr('data-border', toBorderColor)
//         }
//         TweenLite.fromTo($(this), 0.6, {
//             borderColor: '#2E3038'
//         }, {
//             borderColor: toBorderColor,
//             clearProps: 'borderColor'
//         })
//     }
//     var checkName = function(e) {
//         var form = $(this);
//         var input = form.find('input');
//         var button = form.find('.button');
//         var message = form.find('.message-invalid');
//         var name = input.val().replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
//         if (button.hasClass('is-checking')) {
//             e.preventDefault();
//             return
//         }
//         button.addClass('is-checking');
//         form.removeClass('is-invalid');
//         if (name == '') {
//             message.text(nameCheckerMessages.empty);
//             form.addClass('is-invalid');
//             button.removeClass('is-checking');
//             return !1
//         }
//         $.post({
//             url: 'https://staging.caxis.com/app/rest/checkAvailability',
//             contentType: 'application/json',
//             data: JSON.stringify(name),
//             success: function(response) {
//                 if (response == !0) {
//                     button.removeClass('is-checking');
//                     button.addClass('is-valid');
//                     setTimeout(function() {
//                         window.companyName = name;
//                         var url = WRK.host + '/signup';
//                         site.pageLoading(url, !0)
//                     }, 1000)
//                 } else {
//                     message.text(nameCheckerMessages.unavailable);
//                     form.addClass('is-invalid');
//                     button.removeClass('is-checking')
//                 }
//                 console.log('Name checker success', response)
//             },
//             error: function(xhr, status, error) {
//                 if (xhr.status == 503) {
//                     message.text(nameCheckerMessages['503'])
//                 } else {
//                     message.text(nameCheckerMessages.default)
//                 }
//                 form.addClass('is-invalid');
//                 button.removeClass('is-checking');
//                 console.log('Name checker error', error)
//             }
//         });
//         return !1
//     }
//     return {
//         init: init
//     }
// })(jQuery);
//
// function googleMapCallback() {
//     $('body').addClass('has-ggmap');
//     pageContact.initMap()
// }
// site.showPreloader()